export const UnlockFields = {
  No: 0,
  Yes: 1
};

export const UnlockFieldOptions = [
  { value: UnlockFields.Yes, text: "Yes" },
  { value: UnlockFields.No, text: "No" }
];
